import useWebsiteOptionsMutation from './useWebsiteOptionsMutation'

export default useWebsiteOptionsMutation
